// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"237":"forum/components/SignupPage","283":"forum/components/ComposerPage","394":"forum/components/LoginPage","784":"forum/components/ForgotPage"}[chunkId] + ".js";
};